import CloseIcon from './CloseIcon';

export default CloseIcon;
